/**
 * Utilidades para el formateo de fechas en la aplicación
 */

/**
 * Formatea una fecha al formato solicitado: dd/mm/yyyy, hh:mm:ss
 * @param {string|Date} dateString - Fecha en formato ISO string o Date object
 * @returns {string} Fecha formateada
 */
export const formatDateToCustomFormat = (dateString) => {
  if (!dateString) return "";
  
  try {
    const date = new Date(dateString);
    
    // Verificar que la fecha sea válida
    if (isNaN(date.getTime())) {
      return "";
    }
    
    // Obtener componentes de la fecha
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    // Verificar si la fecha tiene información de hora (no es medianoche)
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    
    // Si es medianoche (00:00:00) y no hay milisegundos, probablemente es solo fecha
    const hasTimeInfo = hours !== 0 || minutes !== 0 || seconds !== 0 || date.getMilliseconds() !== 0;
    
    if (hasTimeInfo) {
      // Formato completo: dd/mm/yyyy, hh:mm:ss
      const hoursStr = String(hours).padStart(2, '0');
      const minutesStr = String(minutes).padStart(2, '0');
      const secondsStr = String(seconds).padStart(2, '0');
      return `${day}/${month}/${year}, ${hoursStr}:${minutesStr}:${secondsStr}`;
    } else {
      // Solo fecha: dd/mm/yyyy
      return `${day}/${month}/${year}`;
    }
  } catch (error) {
    console.error("Error formateando fecha:", error);
    return "";
  }
};

/**
 * Formatea una fecha para mostrar solo la fecha (sin hora)
 * @param {string|Date} dateString - Fecha en formato ISO string o Date object
 * @returns {string} Fecha formateada
 */
export const formatDateOnly = (dateString) => {
  if (!dateString) return "";
  
  try {
    const date = new Date(dateString);
    
    if (isNaN(date.getTime())) {
      return "";
    }
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${day}/${month}/${year}`;
  } catch (error) {
    console.error("Error formateando fecha:", error);
    return "";
  }
};

/**
 * Formatea una fecha para mostrar solo la hora
 * @param {string|Date} dateString - Fecha en formato ISO string o Date object
 * @returns {string} Hora formateada
 */
export const formatTimeOnly = (dateString) => {
  if (!dateString) return "";
  
  try {
    const date = new Date(dateString);
    
    if (isNaN(date.getTime())) {
      return "";
    }
    
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return `${hours}:${minutes}:${seconds}`;
  } catch (error) {
    console.error("Error formateando hora:", error);
    return "";
  }
};

/**
 * Función legacy para mantener compatibilidad con el formato anterior
 * @param {string|Date} dateString - Fecha en formato ISO string o Date object
 * @returns {string} Fecha formateada en formato largo español
 */
export const formatDateLegacy = (dateString) => {
  if (!dateString) return "";
  const options = { day: "numeric", month: "long", year: "numeric" };
  return new Date(dateString).toLocaleDateString("es-ES", options);
};

/**
 * Función legacy para formato corto (dd/mm/yy)
 * @param {string|Date} dateString - Fecha en formato ISO string o Date object
 * @returns {string} Fecha formateada en formato corto
 */
export const formatDateShort = (dateString) => {
  if (!dateString) return "";
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit'
    });
  } catch (error) {
    return dateString;
  }
}; 